export enum GLTypes {
  SALES,
  COST_OF_SALES,
  OTHER_INCOME,
  OPERATING_EXPENSES,
  BALANCE_SHEET_CLEARING_ACCOUNTS
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/constants/gl-types.ts